import { IModelEntity } from '@pit/core';
import { IDtoAddress } from './dto.address.interface';

export enum ShipmentDeliveredTo {

    Unknown = 1,
    Recipient = 2,
    AuthorizedPerson = 4,
    Family = 8,
    Roommate = 16,
    Employee = 32

}

export enum ShipmentDeliveredToConfirmation {

    NotNecessary = 1,
    PersonallyKnown = 2,
    IdCard = 4

}
export interface IDtoShipmentProcessRecipient extends IModelEntity {

    deliveredTo?: ShipmentDeliveredTo;
    deliveredToConfirmation?: ShipmentDeliveredToConfirmation;

    name?: string;
    signature?: string;

    address?: IDtoAddress;

    fullAddress?: string;
    fullDescription?: string;
    fullName?: string;

}
